import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=82bfd1f6&scoped=true"
import script from "./Options.vue?vue&type=script&lang=ts"
export * from "./Options.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bfd1f6",
  null
  
)

export default component.exports